var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"afk-panel-tabs__tab",class:{ 'afk-panel-tabs__tab--selected': _vm.isActive(_vm.item) },attrs:{"data-testid":"afk-panel-tabs__tab"},on:{"click":function($event){return _vm.setActivePanel(_vm.item)}}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }